import React,{useState,useEffect} from "react";
import { Chart } from "react-charts";

export const LineChart = (props) => {
  // Define the data
  const [data, setData] = React.useState([
    {
      label: "Series 1",
      data: props.lineData,
      color: '#00954b',
    },
  ]);

  const [axes, setAxes] = React.useState([ { primary: true, type: "ordinal", position: "bottom" },
  { type: "linear", position: "left" },]);

  
  useEffect(()=>{
    if (props.lineData && props.lineData.length > 0) {

      setData([
        {
          label: "Series 1",
          data: props.lineData,
          color: '#00954b',
        },
      ]);
      setAxes([
        { primary: true, type: "ordinal", position: "bottom" },
        { type: "linear", position: "left" },
      ]);

    }
   
  },[props.lineData])

 

  return (
    <div style={{ width: "100%", height: "300px" }}>
      {props.lineData.length>0?<Chart data={data} axes={axes} tooltip
       getDatumStyle={() => ({
        cursor: 'pointer',
      })}

      onClick={(datum) => {
        //alert("i m in click");
        const url = datum.originalDatum.link;
        if (url) {
          window.location.href = url;
        }
      }}
      />:''}
    </div>
  );
};



export const Top_Overall_BarChart = (props) => {
  // Define the data
 // Define the data
 const [data, setData] = React.useState([
  {
    label: "OverAll Top Performerce",
    data: props.lineData,
    color: '#00954b',
  },
]);


const [axes, setAxes] = React.useState([{ primary: true, type: "ordinal", position: "bottom" },
{ type: "linear", position: "left" }]);

const [series, setSeries] = useState({ type: "bar" });




useEffect(()=>{
  if (props.lineData && props.lineData.length > 0) {
    setData([
      {
        label: "Sales",
        data: props.lineData,
        color: '#00954b',
      },
    ]);
  
    setAxes([
      { primary: true, type: "ordinal", position: "bottom" },
  { type: "linear", position: "left" }
    ]);
  
    setSeries({ type: "bar" });

  }

},[props.lineData])

  

 


  return (
    <div style={{ width: "100%", height: "300px" }}>
      {props.lineData.length>0?<Chart data={data} axes={axes} series={series} tooltip 
      
      getDatumStyle={() => ({
        cursor: 'pointer',
      })}

      onClick={(datum) => {
        //alert("i m in click");
        const url = datum.originalDatum.link;
        if (url) {
          window.location.href = url;
        }
      }}
      
      />:''}
      
    </div>
  );
};

export const Comparison_BarChart = () => {
  // Define the data
  const data = React.useMemo(
    () => [
      {
        label: "Sales",
        data: [
          { primary: "-", secondary: 10 },
          { primary: "Total Oil Change(FY-2023)", secondary: 187437},
          { primary: "Total Oil Change(FY-2024)", secondary: 201597 },
          // { primary: "Kanipura Patrol", secondary: 45 },
          // { primary: "Nanakheda Patrol", secondary: 70 },
          // { primary: "Rishi Nagar Patrol", secondary: 70 },
          // { primary: "RD Gaurdi", secondary: 90 },
          // { primary: "Maheshwari Spares", secondary: 120 },
          // { primary: "Basawda Pumps", secondary: 30 },
          // { primary: "Langer Patrol", secondary: 40 },
          // { primary: "Nagjhiri Pumps", secondary: 35 },
        ],
      },
      // {
      //   label: "Revenue",
      //   data: [
      //     { primary: "January", secondary: 60 },
      //     { primary: "February", secondary: 95 },
      //     { primary: "March", secondary: 55 },
      //     { primary: "April", secondary: 85 },
      //   ],
      // },
    ],
    []
  );

  // Define the axes
  const axes = React.useMemo(
    () => [
      { primary: true, type: "ordinal", position: "bottom" },
      { type: "linear", position: "left" },
    ],
    []
  );

  // Bar chart-specific options
  const series = React.useMemo(
    () => ({
      type: "bar", // Use bar chart type
    }),
    []
  );

  return (
    <div style={{ width: "100%", height: "300px" }}>
      <Chart data={data} axes={axes} series={series} tooltip />
    </div>
  );
};




export const BarChart = (props) => {
   // Define the data
  const [data, setData] = React.useState([
    {
      label: "Sales Last 15 Days",
      data: props.lineData,
    },
  ]);

  const handleDatumClick = (datum) => {
    const link = datum.originalDatum.link;
    if (link) {
      window.location.href = link; // or use navigate() if using react-router
    }
  };
  
  const [axes, setAxes] = React.useState([ { primary: true, type: "ordinal", position: "bottom" },
  { type: "linear", position: "left" }]);

  const [series, setSeries] = useState({ type: "bar" });


  
  useEffect(()=>{
    if (props.lineData && props.lineData.length > 0) {
      setData([
        {
          label: "Sales",
          data: props.lineData,
          color: '#00954b',
        },
      ]);

      setAxes([
       { primary: true, type: "ordinal", position: "bottom" },
  { type: "linear", position: "left" },
      ]);

      setSeries({ type: "bar" });

    }
   

  },[props.lineData])

  
    // Define the axes
 
  
    return (
      <div style={{ width: "100%", height: "300px" }}>
        {props.lineData.length>0?<Chart margin={{ left: 30 }} data={data} axes={axes} series={series} tooltip 
        getDatumStyle={() => ({
          cursor: 'pointer',
        })}

        onClick={(datum) => {
          //alert("i m in click");
          const url = datum.originalDatum.link;
          if (url) {
            window.location.href = url;
          }
        }}
        
        />:''}
        
      </div>
    );
  };

export default LineChart;
